import axios from "axios";
const CONTACT_API = process.env.REACT_APP_BACKEND_API;

export const contactUs = async (body) => {
  const { data } = await axios.post(`${CONTACT_API}frontend/contact-messages`, body);
  return data?.data || {};
};
